import React, { useState, useEffect, useCallback } from "react";
import * as WalletApi from "api/student/v2/wallet.api";
import StadiaComponent from "./Stadia.component";
import type { IWalletHistoryItem } from "api/student/v2/wallet.api";

const PAGE_SIZE = 20;

const StadiaContainer: React.FC = () => {
    const [balance, setBalance] = useState<number | null>(null);
    const [isBalanceLoading, setIsBalanceLoading] = useState(true);
    const [list, setList] = useState<IWalletHistoryItem[]>([]);
    const [pagination, setPagination] = useState({ page: 1, limit: PAGE_SIZE, totalCount: 0 });
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);

    const fetchBalance = useCallback(async () => {
        setIsBalanceLoading(true);
        try {
            const res = await WalletApi.getBalance();
            setBalance(res?.balance ?? 0);
        } catch {
            setBalance(0);
        } finally {
            setIsBalanceLoading(false);
        }
    }, []);

    const fetchHistory = useCallback(async (page: number, append: boolean) => {
        if (page === 1) setIsLoading(true);
        else setIsLoadingMore(true);
        try {
            const res = await WalletApi.getHistory({ page, limit: PAGE_SIZE });
            if (res?.list) {
                setList((prev) => (append ? [...prev, ...res.list] : res.list));
            }
            if (res?.pagination) {
                setPagination(res.pagination);
            }
        } catch {
            if (!append) setList([]);
        } finally {
            setIsLoading(false);
            setIsLoadingMore(false);
        }
    }, []);

    useEffect(() => {
        fetchBalance();
    }, [fetchBalance]);

    useEffect(() => {
        fetchHistory(1, false);
    }, [fetchHistory]);

    const onLoadMore = useCallback(() => {
        if (list.length >= pagination.totalCount) return;
        fetchHistory(pagination.page + 1, true);
    }, [list.length, pagination.totalCount, pagination.page, fetchHistory]);

    return (
        <StadiaComponent
            balance={balance}
            isBalanceLoading={isBalanceLoading}
            list={list}
            pagination={pagination}
            isLoading={isLoading}
            isLoadingMore={isLoadingMore}
            onLoadMore={onLoadMore}
        />
    );
};

export default StadiaContainer;
